var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9075_46347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7972 16.891C21.374 17.8283 20.65 19 19.4979 19H4.50145C3.34717 19 2.62648 17.8265 3.20217 16.891L10.7005 4.70269C11.2776 3.76492 12.723 3.76662 13.299 4.70269L20.7972 16.891ZM11.9998 14.3711C11.2059 14.3711 10.5623 14.9745 10.5623 15.7188C10.5623 16.463 11.2059 17.0664 11.9998 17.0664C12.7937 17.0664 13.4373 16.463 13.4373 15.7188C13.4373 14.9745 12.7937 14.3711 11.9998 14.3711ZM10.635 9.52697L10.8668 13.5113C10.8776 13.6978 11.0421 13.8438 11.2412 13.8438H12.7583C12.9575 13.8438 13.1219 13.6978 13.1327 13.5113L13.3645 9.52697C13.3763 9.32559 13.2052 9.15625 12.9901 9.15625H11.0094C10.7943 9.15625 10.6233 9.32559 10.635 9.52697Z",
    fill: "#DF5031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9075_46347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "translate(3 4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/DangerIcon.f854767edb5236f8d113bf3aae850c83.svg";
export { ForwardRef as ReactComponent };